$.fn.scrollToAnchor = function() {
  let self = this

  self.click(function() {
    hash = $(this).attr('href');
    targetTop = $(hash).offset().top;
    targetTop -= $('.header__main').outerHeight() + ($.mlmi.mobile.isMobile ? 40 : 40)
    $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
    return false;
  });

  return function() {
    return self
  }()
};
